import { QuestionTypeToClassMap } from 'app/models/questions/QuestionTypeToClassMap'

export class QuestionFactoryValidationError extends Error {
  constructor(unknownQuestionType: string, questionKey: string) {
    super()
    this.name = 'Invalid question type received from server'
    this.message = `The question with key ${questionKey} has an invalid type of <${unknownQuestionType}>. Supported types are ${Object.keys(QuestionTypeToClassMap).join(', ')}`
  }
}
